module.exports = __webpack_public_path__ + "img/u2968.20eddc4e.png";